import type { ThemeConfig } from "antd";

export const noRowSelectionBgTheme: ThemeConfig = {
  components: {
    Table: {
      rowSelectedBg: "#ffffff",
      rowSelectedHoverBg: "#ffffff",
      rowHoverBg: "#ffffff",
    },
  },
};
